<template>
  <div class="confectionModal">
    <div class="confectionModal-top">
      <img
        class="confectionModal-image img-responsive"
        alt="envelope example"
        :src="image"
        width="350px"
      >
    </div>

    <div class="confectionModal-content">
      <h2 class="confectionModal-title">Koperty na karty z etykietami</h2>
      <section class="confectionModal-descriptions">
        <p>Aby uświetnić prezent i sprawić, że każdy pracownik poczuje się wyróżniony, możesz zamówić etykietowane koperty z imieniem, nazwiskiem i kwotą zasilenia.</p>
      </section>
      <section>
        <p>
          <a :href="file" target="_blank" class="text-underline">Pobierz szablon</a>
          , aby uzupełnić dane, które zostaną nadrukowane na kopertach. Plik będziesz mógł załączyć w kroku „DOSTAWA”.
        </p>
      </section>
      <section class="confectionModal-warnings">
        <p>
          UWAGA! Przed wysłaniem sprawdź, czy liczba zamawianych kopert jest zgodna z liczbą rekordów w pliku excel. Liczba zamówionych kopert z etykietami musi być zgodna z liczbą rekordów w pliku excel. Liczba zamawianych kopert z etykietami musi być dokładnie taka sama jak liczba zamawianych kart.
        </p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'envelopeCardModal',
  props: {
    image: {
      type: String,
      required: true,
    },
    file: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
